import { Box } from '@mui/material';
import CookieBot from 'react-cookiebot';

export const CookiesPopup = () => (
  <Box>
    <CookieBot domainGroupId="3befa988-6021-4615-a7e7-7949e343bcf0" />
  </Box>
);
